import React from "react";

function RequestItem({ fieldName, fieldValue }) {
  return (
    <div className="request-item">
      <span className="request-label">{fieldName}</span>
      <span className="request-value">{fieldValue}</span>
    </div>
  );
}

export default RequestItem;